import { RouteType } from 'types/RouteType'; // Adjust the import path as necessary
import databaseManagerRoute from './DatabaseManager/databaseManager.Route';
import createJobRoute from './CreateJob/CreateJob.Route';
import panelManagementRoute from './PanelManagement/PanelManagement.Route';

const adminRoutesList: RouteType[] = [
  databaseManagerRoute,
  createJobRoute,
  panelManagementRoute,
];

export default adminRoutesList;
